import axios from "axios";

const api = axios.create({
  baseURL: "/api",
});

// Injeta o token em todas as requisições automaticamente
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Redireciona para login se token expirar
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

// ── Auth ─────────────────────────────────────────────────────────────────────

export const login = async (email, password) => {
  const form = new URLSearchParams();
  form.append("username", email);
  form.append("password", password);
  const { data } = await api.post("/auth/login", form);
  return data;
};

export const getMe = async () => {
  const { data } = await api.get("/auth/me");
  return data;
};

export const listUsers = async () => {
  const { data } = await api.get("/auth/users");
  return data;
};

export const createUser = async (payload) => {
  const { data } = await api.post("/auth/register", payload);
  return data;
};

export const deactivateUser = async (id) => {
  const { data } = await api.delete(`/auth/users/${id}`);
  return data;
};

export const toggleUserActive = async (id) => {
  const { data } = await api.patch(`/auth/users/${id}/toggle-active`);
  return data;
};

export const updateUserRole = async (id, is_admin) => {
  const { data } = await api.patch(`/auth/users/${id}/role`, { is_admin });
  return data;
};

// ── Analysis ─────────────────────────────────────────────────────────────────

export const createAnalysis = async (formData) => {
  const { data } = await api.post("/analysis/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const listAnalyses = async () => {
  const { data } = await api.get("/analysis/");
  return data;
};

export const getAnalysis = async (id) => {
  const { data } = await api.get(`/analysis/${id}`);
  return data;
};

export const deleteAnalysis = async (id) => {
  const { data } = await api.delete(`/analysis/${id}`);
  return data;
};

// ── Versões (recálculo, só admin) ────────────────────────────────────────────

export const listVersions = async (id) => {
  const { data } = await api.get(`/analysis/${id}/versoes`);
  return data;
};

export const getVersion = async (id, versionId) => {
  const { data } = await api.get(`/analysis/${id}/versoes/${versionId}`);
  return data;
};

export const recalculateAnalysis = async (id) => {
  const { data } = await api.post(`/analysis/${id}/recalcular`);
  return data;
};

export default api;
